export const AFFILIATE_CLICK_SCRIPT_URL =
  "https://affiliate.shopping-cart-migration.com/scripts/clickjs.php";

export const AFFILIATE_SALE_SCRIPT_URL =
  "https://affiliate.shopping-cart-migration.com/scripts/salejs.php";
